var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"submit-btn-container"},[_c('button',{staticClass:"btn",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v(_vm._s(_vm.$t("QUESTION_FORM.SUBMIT")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }